var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgStack = function SvgStack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 11.2 6.542-4.584L16 5.6 8 0 0 5.6l1.449 1.016zm0 2.032L1.44 8.648 0 9.656l8 5.6 8-5.6-1.449-1.016z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStack);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;